import React from "react";
import { Link } from "react-router-dom";
import { Button, Space } from "antd";
import styled from "styled-components";
import assignmentTypes from "constants/assignmentTypes";

const StyledDeleteButton = styled(Button)`
  padding: 0px;
  margin: 0px;
`;

const localeColumns = ({ onDelete, schoolId }) => [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Locales",
    dataIndex: "displayName",
    key: "displayName",
  },
  {
    title: "Assignment Type",
    key: "assignmentType",
    render: ({ assignmentType }) => assignmentTypes[assignmentType],
  },
  {
    title: "Name",
    key: "assignmentRefName",
    dataIndex: "assignmentRefName",
  },
  {
    title: "Action",
    key: "action",
    render: (_text, record) => {
      const { id } = record;

      return (
        <Space size="middle">
          <Link
            to={{
              pathname: `/schools/${schoolId}/locales/${id}`,
              state: { id },
            }}
          >
            View
          </Link>
          |
          <StyledDeleteButton
            className="delete-button"
            type="link"
            onClick={() => onDelete({ record })}
          >
            Delete
          </StyledDeleteButton>
        </Space>
      );
    },
  },
];

export default localeColumns;
